import React from 'react';
import { Button, Col, Card, Row } from 'react-bootstrap';
import { conConfig } from '@victorequena22/conneccion';
import { ControlText } from '@victorequena22/component-bootstrap';
interface State {
    tag: string
    ads: string
    adsConversion: string
}
export default class GoogleTag extends React.Component<any, State> {
    con = conConfig('google-tag');
    state = { tag: '', ads: '', adsConversion: '' };
    render() {
        let { tag, ads, adsConversion } = this.state;
        return (<Card>
            <Card.Header className='bg-info'>
                <h4 className='mr-auto'><i className="fa fa-edit"></i> CONFIGURACION DE GOOGLE TAG </h4>
            </Card.Header>
            <Card.Body>
                <Row className='mt-2'>
                    <ControlText before="GOOGLE TAG" maxLength={200} value={tag} update='tag' setData={this.setState.bind(this)} />
                </Row>
                <Row className='mt-2'>
                    <ControlText before="GOOGLE ADS" maxLength={200} value={ads} update='ads' setData={this.setState.bind(this)} />
                </Row>
                <Row className='mt-2'>
                    <ControlText before="GOOGLE ADS CONVERSION" maxLength={200} value={adsConversion} update='adsConversion' setData={this.setState.bind(this)} />
                </Row>
                <Col md={12}><br />
                    <Button className="float-right" onClick={this.guardar.bind(this)} variant="primary">
                        <span className="fas fa-save" /> Guardar
                    </Button>
                </Col>
            </Card.Body>
        </Card>)
    }
    componentDidMount() {
        this.con.pull(this.setState.bind(this));
    }
    guardar() {
        this.con.push(this.state, this.setState.bind(this));
    }
}
